import { init } from './init';

export interface ConfigScriptParams {
  apiKey: string;
}

/**
 * Генерирует inline-скрипт для вставки в HTML
 */
export function generateConfigScript(params: ConfigScriptParams): string {
  const { apiKey } = params;

  const initFnString = init.toString();

  const configData = JSON.stringify({ apiKey });

  return `\n(${initFnString})(${configData})\n`;
}
